import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import 'mapbox-gl/dist/mapbox-gl.css';

const AddressForm = ({ setProps, fullAddress, lat, lon, city, state, zipCode, timeZone, placeholder }) => {
    const geocoderContainerRef = useRef(null);

    // Mapbox Geocoder access token
    const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiYnZyZWVsYW5kIiwiYSI6ImNrZmQ5YzlzNTA2Y3Myd3B0eWFua2F1eHcifQ.47g7rOoMFcFzuS93B-_jcQ';

    // TimeZoneDB API key (you'll need to sign up for a free API key)
    const TIMEZONEDB_API_KEY = 'YOUR_TIMEZONEDB_API_KEY';

    useEffect(() => {
        if (!geocoderContainerRef.current) return;

        const geocoder = new MapboxGeocoder({
            accessToken: MAPBOX_ACCESS_TOKEN,
            types: 'address',
            countries: 'us',
            placeholder: placeholder || 'Enter an address',
        });

        geocoder.addTo(geocoderContainerRef.current);

        geocoder.on('result', async (e) => {
            const result = e.result;
            const selectedAddress = result.place_name;
            const [longitude, latitude] = result.center;

            // Extract additional information
            const context = result.context || [];
            const cityInfo = context.find(item => item.id.startsWith('place'));
            const stateInfo = context.find(item => item.id.startsWith('region'));
            const postalInfo = context.find(item => item.id.startsWith('postcode'));

            const city = cityInfo ? cityInfo.text : '';
            const state = stateInfo ? stateInfo.short_code.split('-')[1] : '';
            const zipCode = postalInfo ? postalInfo.text : '';

            // Fetch time zone information
            try {
                const timeZoneResponse = await fetch(`http://api.timezonedb.com/v2.1/get-time-zone?key=${TIMEZONEDB_API_KEY}&format=json&by=position&lat=${latitude}&lng=${longitude}`);
                const timeZoneData = await timeZoneResponse.json();
                const timeZone = timeZoneData.zoneName;

                updateDash(selectedAddress, latitude, longitude, city, state, zipCode, timeZone);
            } catch (error) {
                console.error("Error fetching time zone:", error);
                updateDash(selectedAddress, latitude, longitude, city, state, zipCode, null);
            }
        });

        return () => {
            geocoder.onRemove();
        };
    }, [placeholder]);

    // Function to update Dash
    const updateDash = (address, latitude, longitude, city, state, zipCode, timeZone) => {
        if (setProps) {
            const updatedProps = {
                fullAddress: address,
                lat: latitude,
                lon: longitude,
                city: city,
                state: state,
                zipCode: zipCode,
                timeZone: timeZone
            };
            setProps(updatedProps);
            console.log("Data passed to Dash:", updatedProps);
        } else {
            console.warn("setProps is not available");
        }
    };

    // Use useEffect to update Dash when component mounts or props change
    useEffect(() => {
        if (fullAddress && lat && lon) {
            updateDash(fullAddress, lat, lon, city, state, zipCode, timeZone);
        }
    }, [fullAddress, lat, lon, city, state, zipCode, timeZone]);

    return (
        <div className="address-form">
            <div ref={geocoderContainerRef}></div>
        </div>
    );
};

AddressForm.propTypes = {
    id: PropTypes.string,
    setProps: PropTypes.func,
    fullAddress: PropTypes.string,
    lat: PropTypes.number,
    lon: PropTypes.number,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
    timeZone: PropTypes.string,
    placeholder: PropTypes.string,
};

export default AddressForm;
